import axios from "axios";
import { stringify } from "query-string";

import * as constants from "../../constants";
import { AXIOS_DEFAULT_OPTIONS } from "../";
import { getConfig } from "../../reducers/portalConfig";
import { getValidationErrors } from "../../utils";

const fetchQueryString = (params) => {
  let queryString = stringify(params, true);
  queryString = queryString ? `?${queryString}` : "";
  return queryString;
};

export const fetchCustomFieldsLegacy = () => async (dispatch, getState) => {
  const SELECT = "Uuid,Name,Type,EntityType,Required,Status";
  const INLINE_COUNT = "allpages";
  const ENCODE_RESPONSE = "false";
  const params = {
    // skip: skip,
    // top: top,
    select: SELECT,
    inlinecount: INLINE_COUNT,
    encodeResponse: ENCODE_RESPONSE,
  };
  const queryString = fetchQueryString(params);
  const config = getConfig(getState());
  const { portal } = config;
  const url = `${portal.hostname}/api/${portal.tenantPrefix}/CustomFields${queryString}`;

  await axios
    .get(url, AXIOS_DEFAULT_OPTIONS)
    .then((response) => {
      dispatch({
        type: constants.FETCH_SETTINGS_CUSTOM_FIELDS_SUCCESS,
        isLoading: false,
        payload: response.data,
      });
    })
    .catch((error) =>
      dispatch({
        type: constants.FETCH_SETTINGS_CUSTOM_FIELDS_ERROR,
        payload: getValidationErrors(error),
      }),
    );
};

export const deleteCustomFields = (data) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
   
    const url = `${portal.hostname}/admin/Portal.svc/CustomFields('${data.Uuid}')`;
    await axios.delete(url, data, AXIOS_DEFAULT_OPTIONS)
      .then(response =>
        dispatch({
          type: constants.CUSTOM_FIELDS_DELETE_SUCCESS,
          payload: response.data,
        }),
      )
      .catch(error =>
        dispatch({
          type: constants.CUSTOM_FIELDS_DELETE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };
